
import { useState, useEffect, useRef } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import BottomNavigation from './BottomNavigation';
import CookieBanner from './CookieBanner';
import { useIsMobile } from '@/hooks/use-mobile';
import { useLocation, Outlet, useNavigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const Layout = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  
  // We're always in dark mode
  const isDarkTheme = true;
  const toggleTheme = () => {};

  // Simulate initial loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  // Check if current page is a booking flow page
  const isBookingFlow = location.pathname.includes('/booking') && !location.pathname.includes('/complete');
  
  // Track route changes to reset scroll position
  const prevPathRef = useRef(location.pathname);
  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      window.scrollTo(0, 0);
      prevPathRef.current = location.pathname;
    }
  }, [location.pathname]);
  
  return (
    <div className="flex flex-col min-h-screen bg-[#212121]">
      <Navbar isDarkTheme={isDarkTheme} toggleTheme={toggleTheme} />
      
      {isLoading ? (
        <div className="flex-grow flex items-center justify-center pt-20 md:pt-24">
          <motion.div 
            className="flex flex-col items-center" 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            transition={{ duration: 0.5 }}
          >
            <div className="relative flex items-center justify-center">
              <Loader2 className="h-10 w-10 md:h-12 md:w-12 animate-spin text-[#2C6E49]" />
              <div className="absolute inset-0 border-t-2 border-[#2C6E49] opacity-20 rounded-full"></div>
            </div>
            <p className="mt-4 text-[#F8F8F8]/80 text-base md:text-lg">Wird geladen...</p>
          </motion.div>
        </div>
      ) : (
        <AnimatePresence mode="wait">
          <motion.main 
            key={location.pathname} 
            initial={{ opacity: 0, y: 8 }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
            className={`pt-16 md:pt-20 ${isMobile ? 'pb-24' : 'pb-0'} safe-area-bottom`}
          >
            <Outlet />
          </motion.main>
        </AnimatePresence>
      )}
      
      {!isMobile && <Footer />}
      
      {isMobile && !isBookingFlow && <BottomNavigation />}
      
      <CookieBanner />
    </div>
  );
};

export default Layout;
